module.exports = __webpack_public_path__ + "assets/img/pasta_maker_active.8259c367.png";